import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { getCorrelationId, isSignedInSelector } from '../../app/selectors/contactUsSelector';
import { RequestCreationTabView } from '../presentationalComponents/RequestCreationTabView';
import { getContactUsStyles } from '../styles/contactUsStyles';
import { getTheme } from '../styles/themes';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    correlationId: getCorrelationId(state),
    theme: getTheme(state),
    isSignedIn: isSignedInSelector(state),
  };
};

export const RequestCreationTabViewContainer = connect(
  mapStateToProps
)(styled(RequestCreationTabView, getContactUsStyles));
